module.exports = __webpack_public_path__ + "static/media/network-rail-logo.f588c177.jpeg";